module.exports = "/_next/static/images/0967236cf5109abd51a7195c0d53c713-cards.png.webp";